var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {
    'dataPagesPagination parent centered margin-top_increased-quarter margin-top_increased-tabletLess padding-bottom_increased-tabletLess': true

}, _obj[_vm.className] = _vm.className, _obj[("dataPagesPagination_" + _vm.modifier)] = _vm.modifier, _obj )},[_c('div',{class:{
      'paginationButtons parent_inline row sorterSection_styled sorterSection sorterSection_zeroVerticalPadding': true,
      'margin-left_auto': _vm.rightPosition,
      'margin-right_auto': _vm.leftPosition,
      'paginationButtons_bloated': _vm.bloatedPagination
  }},_vm._l((_vm.quantityPages),function(pageNumber,index){return _c('base-button',{key:index,attrs:{"action":_vm.onClickPaginationButton(pageNumber),"modifier":_vm.currentPageNumber === pageNumber ? _vm.activeColor : 'color-gray',"unstyled":_vm.currentPageNumber !== pageNumber,"class-name":"circle paginationButtons__button font-size_11","pagination":""}},[_vm._v("\n      "+_vm._s(pageNumber)+"\n    ")])}))])
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02e6d522","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/DataPagination.vue
// module id = null
// module chunks = 